import { render, staticRenderFns } from "./Investors.vue?vue&type=template&id=38db7ac6&scoped=true&"
import script from "./Investors.vue?vue&type=script&lang=js&"
export * from "./Investors.vue?vue&type=script&lang=js&"
import style0 from "./Investors.vue?vue&type=style&index=0&id=38db7ac6&scoped=true&lang=css&"
import style1 from "./Investors.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db7ac6",
  null
  
)

export default component.exports